import { Injectable } from '@angular/core';
import { IconsumptionResponse } from '@/app/core/interfaces/consumption.interface';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetConsumptionsAction } from './consumption.actions';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';
import { ConsumeService } from '@/app/core/services/consume/consume.service';

export interface ConsumptionsStateModel {
  consumptions: any;
}

@State<ConsumptionsStateModel>({
  name: 'Consumption',
  defaults: {
    consumptions: [],
  },
})
@Injectable()
export class ConsumptionsState {
  @Selector() static GetAllConsuptions(
    state: ConsumptionsStateModel
  ): IconsumptionResponse[] {
    return state?.consumptions ? state.consumptions : [];
  }

  constructor(
    private consumeService: ConsumeService,
    public dialog: MatDialog
  ) {}

  @Action(GetConsumptionsAction)
  async GetConsumptionsAction(
    ctx: StateContext<ConsumptionsStateModel>,
    { payload }: GetConsumptionsAction
  ) {
    ctx.patchState({
      consumptions: [],
    });
    try {
      const resp = await this.consumeService.getAllConsume(payload);
      ctx.patchState({
        consumptions: resp,
      });
    } catch (error) {
      this.dialog.open(EnovaAlertsComponent, {
        width: 'auto',
        data: {
          type: 'error',
          text: 'Ha ocurrido un error al obtener los consumos',
          hiddeCancelBtn: true,
        },
      });
    }
  }
}
